import { makeStyles } from 'tss-react/mui';

import { ObjectFitType } from './ImageWithLoader';

interface StyleProps {
  width: string;
  height: string;
  objectFit: ObjectFitType;
  aspectRatio?: string;
}

export const useStyles = makeStyles<StyleProps>()(
  (theme, { height, width, objectFit, aspectRatio }) => ({
    img: {
      objectFit: objectFit,
      height: height,
      width: width,
    },
    wrapper: {
      aspectRatio: aspectRatio,
    },
  }),
);
